import React, { useEffect, useState } from "react";
import { Slider as SliderAntd, InputNumber, Row, Col } from "antd";

import { FormItem, Label } from "./styles";

const Slider = ({ name, min, max, value, callback, unit, disabled }) => {
  const [val, setval] = useState(null);

  //On value changes
  useEffect(() => {
    if (!val) setval(value);
  }, [value, val]);

  const handleChangue = (val) => {
    setval(val);
    handleAfterChange(val);
  };

  const handleAfterChange = (val) => callback(val);
  return (
    <Row type="flex" align="middle" style={{ margin: 0 }}>
      <Col span={24}>
        <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
          <Col>
            <FormItem>
              <Label>{name}</Label>
            </FormItem>
          </Col>
          <Col>
            <InputNumber
              min={min}
              max={max}
              value={typeof val === "number" ? val : 0}
              onChange={handleChangue}
              step={1}
              style={{ verticalAlign: "middle", borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
              /*formatter={value => `${value} mm`}*/
            />
            <div
              className="ant-input-group-addon"
              style={{ paddingTop: "2px", verticalAlign: "middle", display: "inline-table", lineHeight: "24px", height: "32px" }}
            >
              {unit}
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <SliderAntd min={min} max={max} tooltipVisible={false} onChange={handleChangue} value={typeof val === "number" ? val : 0} />
      </Col>{" "}
    </Row>
  );
};

export default Slider;
